import React from 'react'

// Mapping per tutte le lingue che usano il CMS
const FLAG_FILE_MAP = {
  it: 'it.png',
  en: 'gb.png',
  es: 'es.png',
  de: 'de.png',
  fr: 'fr.png',
  el: 'gr.png'
}

const getFlagUrl = (langCode) => {
  const fileName = FLAG_FILE_MAP[langCode]
  return fileName ? `${process.env.CMS_URL}/images/flags/${fileName}` : null
}

const bank = process.env.BANK

const languages = [
  {
    supportedBanks: ['UCI', 'NEXIBUSINESS'],
    label: 'IT',
    value: 'it',
    extendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('it')} alt='IT' aria-hidden /> IT
      </div>
    ),
    longExtendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('it')} alt='IT' aria-hidden /> Italiano
      </div>
    ),
    flag: getFlagUrl('it')
  },
  {
    supportedBanks: ['UCI', 'NEXIBUSINESS'],
    label: 'EN',
    value: 'en',
    extendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('en')} alt='EN' aria-hidden /> EN
      </div>
    ),
    longExtendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('en')} alt='English' aria-hidden /> English
      </div>
    ),
    flag: getFlagUrl('en')
  },
  {
    supportedBanks: ['NEXIBUSINESS'],
    label: 'ES',
    value: 'es',
    extendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('es')} alt='ES' aria-hidden /> ES
      </div>
    ),
    longExtendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('es')} alt='Español' aria-hidden /> Español
      </div>
    ),
    flag: getFlagUrl('es')
  },
  {
    supportedBanks: ['NEXIBUSINESS'],
    label: 'DE',
    value: 'de',
    extendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('de')} alt='DE' aria-hidden /> DE
      </div>
    ),
    longExtendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('de')} alt='Deutsch' aria-hidden /> Deutsch
      </div>
    ),
    flag: getFlagUrl('de')
  },
  {
    supportedBanks: ['NEXIBUSINESS'],
    label: 'FR',
    value: 'fr',
    extendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('fr')} alt='FR' aria-hidden /> FR
      </div>
    ),
    longExtendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('fr')} alt='Français' aria-hidden /> Français
      </div>
    ),
    flag: getFlagUrl('fr')
  },
  {
    supportedBanks: ['NEXIBUSINESS'],
    label: 'EL',
    value: 'el',
    extendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('el')} alt='EL' aria-hidden /> EL
      </div>
    ),
    longExtendedLabel: (
      <div className='merchantLanguageSelectItem'>
        <img className='countryFlag' src={getFlagUrl('el')} alt='Ελληνικά' aria-hidden /> Ελληνικά
      </div>
    ),
    flag: getFlagUrl('el')
  }
]

const supportedNotificationSystems = [
  {
    supportedBanks: ['UCI', 'NEXIBUSINESS'],
    name: 'firebase'
  },
  {
    supportedBanks: ['NEXIBUSINESS'],
    name: 'marketing_cloud'
  }
]

const cookiePolicyHandlers = [
  {
    supportedBanks: ['UCI'],
    action: () => window.Didomi ? window.Didomi.preferences.show() : ''
  },
  {
    supportedBanks: ['NEXIBUSINESS'],
    getPath: (linksConfig) => ({ path: linksConfig.cookies, isExternal: true, newTab: true })
  }
]

const componentConfig = {
  /**
    components: src/components/MerchantLanguageSelect.jsx, src/routes/Profile/components/Settings/Settings.jsx
    routes: /login, /profile/settings
  */
  languageSelect: {
    /**
     * Filters the list of languages to return only those that support the specified bank.
     *
     * @function
     * @returns {Array} An array of language objects that support the specified bank.
     */
    availableLanguages: () => languages.filter((language) => language.supportedBanks.includes(bank)),
  },
  availableNotifications: () => supportedNotificationSystems.filter((system) => system.supportedBanks.includes(bank)).map(systemNotification => systemNotification.name),
  /**
    components: src/components/Template/FlowTemplate/FlowTemplateContainer.js, src/components/Template/PageTemplate/PageTemplateContainer.js
    Used for configuring cookie policy handling based on bank
  */
  cookiePolicy: {
    /**
     * Gets the cookie policy configuration for footer links
     *
     * @function
     * @param {Object} linksConfig - Links configuration object
     * @returns {Object} Cookie policy configuration object
     */
    getCookieConfig: (linksConfig) => {
      const handler = cookiePolicyHandlers.find((handler) => handler.supportedBanks.includes(bank))
      if (!handler) return {}

      return handler.action ? { action: handler.action } : handler.getPath(linksConfig)
    }
  },
  chatbot: {
    isEnabled: () => {
      const supportedBanks = ['NEXIBUSINESS']
      return supportedBanks.includes(bank)
    }
  }
}


export default componentConfig
